var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBronzePodiumWithNumber = function SvgBronzePodiumWithNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA789",
    d: "M0 0h95a4 4 0 0 1 4 4v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4435C",
    d: "M0 16h99v52H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.744 36.648c0 1.792-.832 3.36-2.273 4.448 1.793 1.216 2.88 3.072 2.88 5.28 0 4.064-3.584 6.976-8.224 6.976-4.32 0-7.84-2.624-8.128-6.24l4.064-.32c.416 1.76 2.112 2.912 4.064 2.912 2.496 0 4.352-1.472 4.352-3.488s-1.855-3.456-4.352-3.456h-1.184l.032-3.168h1.152c2.208 0 3.808-1.248 3.808-2.944s-1.632-2.976-3.872-2.976c-1.568 0-3.104.736-3.68 2.08l-3.904-.256c.513-3.04 3.648-5.28 7.584-5.28 4.48 0 7.68 2.688 7.68 6.432"
  })));
};
export default SvgBronzePodiumWithNumber;